import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { NavConfig } from './nav-config';
import { EnterpriseLabels } from '../../common/interfaces/enterprise-labels';

@Component({
    selector: 'lib-breadcrumbs',
    standalone: true,
    imports: [
        NgForOf,
        RouterLink,
        NgIf,
        NgClass
    ],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent implements OnInit {
    private readonly router = inject(Router);


    @Input() breadcrumbs: NavConfig[] | null = null;
    @Input() enterpriseLabels!: EnterpriseLabels;

    ngOnInit(): void {
        this.setupBreadcrumbs();
    }

    private setupBreadcrumbs(): void {
        if (!this.breadcrumbs) {
            this.breadcrumbs = this.createBreadcrumbs(this.router.routerState.snapshot.root);
            this.router.events
                .pipe(filter(event => event instanceof NavigationEnd))
                .subscribe(() => {
                    this.breadcrumbs = this.createBreadcrumbs(this.router.routerState.snapshot.root);
                });
        }
    }

    private createBreadcrumbs(route: ActivatedRouteSnapshot, breadcrumbs: NavConfig[] = []): NavConfig[] {
        const child = route?.firstChild as ActivatedRouteSnapshot;
        if (child) {
            let label = child.data[ 'breadcrumb' ] as string;

            switch (label) {
                case 'universalIds':
                    label = this.enterpriseLabels.universalIdsLabel;
                    break;
                case 'emaAccounts':
                    label = this.enterpriseLabels.accountsLabel;
                    break;
                case 'idManagement':
                    label = this.enterpriseLabels.idManagementLabel;
                    break;
            }

            if (label) {
                const isLink = (child.data[ 'isLink' ] as boolean) ?? false;

                let router: string[] = breadcrumbs.filter(item => !!item.router)
                    .map(item => item.router) as string[];
                if (child.url) {
                    router = router.concat(child.url.map(url => url.path));
                }

                breadcrumbs.push({
                    label,
                    isLink,
                    router
                });
            }
            return this.createBreadcrumbs(child, breadcrumbs);
        }
        return breadcrumbs;
    }

    getDataIdentifier(item: NavConfig): string {
        return item.dataIdentifier ?? item.label.replace(/\s+/g, '-').toLowerCase();
    }
}
